var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1801 16.5944C11.6464 19.4246 6.47382 19.2018 3.19811 15.9261C-0.316607 12.4114 -0.316607 6.71289 3.19811 3.19817C6.71283 -0.316546 12.4113 -0.316545 15.926 3.19817C19.2017 6.47388 19.4245 11.6464 16.5943 15.1801L23.4685 22.0543C23.859 22.4448 23.859 23.078 23.4685 23.4685C23.078 23.8591 22.4448 23.8591 22.0543 23.4685L15.1801 16.5944ZM4.61232 14.5119C1.87866 11.7782 1.87866 7.34606 4.61232 4.61239C7.34599 1.87872 11.7781 1.87872 14.5118 4.61239C17.2435 7.34405 17.2455 11.7717 14.5178 14.5059C14.5158 14.5078 14.5138 14.5098 14.5118 14.5118C14.5098 14.5139 14.5078 14.5159 14.5058 14.5179C11.7717 17.2456 7.34399 17.2435 4.61232 14.5119Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico-search.21cacb170b41ec9b767f0b215a1d8c57.svg";
export { ForwardRef as ReactComponent };